import _ from 'lodash';
import config from './default';

const dev = _.cloneDeep(config);

export default dev;
